import type React from "react";
import AuthLayout from "../../components/auth/AuthLayout";
import SignupForm from "../../components/auth/SignupForm";

const SignupPage: React.FC = () => {
  return (
    <AuthLayout
      title="Create Account"
      subtitle="Join RKB LMS and start your learning journey"
      maxWidth="lg"
     showLogo={true} 
      allowScroll={true}
    >
      <SignupForm />
    </AuthLayout>
  );
};

export default SignupPage;
